import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DashboardModel } from '@app/core/Models';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexNoData,
  ApexPlotOptions,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';

import { Observable } from 'rxjs';

export type CashFlowChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  noData: ApexNoData;
};

@Component({
  selector: 'app-dashboard-cashflow-chart',
  templateUrl: './dashboard-cashflow-chart.component.html',
  styleUrls: ['./dashboard-cashflow-chart.component.scss'],
})
export class DashboardCashflowChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  public cashFlowChartOptions: Partial<CashFlowChartOptions>;
  reportList: DashboardModel;

  @Input()
  triggerCashFlow: Observable<any>;

  ngOnInit(): void {
    this.triggerCashFlow.subscribe((data) => {
      this.reportList = data;
      this.getCashflowChart();
    });
  }

  getCashflowChart(): void {
    const incomes: any = [];
    const tempCategories: any = [];
    const expenses: any = [];

    for (const barchart of this.reportList[`categories`]) {
      tempCategories.push(barchart);
    }

    for (const barchart of this.reportList[`series`]) {
      incomes.push(barchart['income']);
    }

    for (const barchart of this.reportList[`series`]) {
      expenses.push(barchart['expense']);
    }

    this.cashFlowChartOptions = {
      series: [
        {
          name: 'Income',
          data: incomes,
        },
        {
          name: 'Expense',
          data: expenses,
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      tooltip: {
        marker: {
          show: false,
        },
        enabled: true,
        fillSeriesColor: false,
      },
      xaxis: {
        categories: tempCategories,
      },
      noData: {
        text: 'No Data to Display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#6d41a1',
          fontSize: '18px',
        },
      },
      fill: {
        opacity: 1,
        type: 'gradient',
        colors: ['#9966D4'],
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.5,
          gradientToColors: ['#F3ACC4'],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
    };
  }
}
